import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './manage-purchase.component'

import MyPurchase   from './my-purchase'
import Confirmation from './confirmation'

let module = angular.module('managePurchase', [
  uiRouter,
  MyPurchase,
  Confirmation
])

.config(($stateProvider) => {
  'ngInject'

  $stateProvider
    .state('managePurchase', {
      url: '/purchase?token',
      component: 'managePurchase',
      redirectTo: 'managePurchase.myPurchase',
      authenticate: true
    })
})

.component('managePurchase', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/index.js